
import React, { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import beds from "../assect/images/icons/sleeping.png";
import baths from "../assect/images/icons/bath-tub.png";
import sqft from "../assect/images/icons/house-size.png";
import calendar from "../assect/images/icons/calendar.png";
import term from "../assect/images/icons/file.png";
const PropertyCard = React.memo(({ item, onPropertyClicked, onMouseEnter, thumbNails }) => {
    const navigate = useNavigate();

    const handlePropertyClicked = useCallback(() => {
        if (onPropertyClicked) {
            onPropertyClicked({ lat: item.lat, lng: item.lng });
        }
    }, [onPropertyClicked, item.lat, item.lng]);

    const handleApplyNowClicked = useCallback(() => {
        navigate('/hemlaneembed');
    }, [navigate]);

    const formatDate = useCallback((date) => {
        return new Date(date).toLocaleDateString('en-US');
    }, []);

    // Memoize the thumbnail URL
    const thumbnailUrl = useMemo(() => {
        return thumbNails[0]?.thumbnailUrl || "/ImageNotFound.png";
    }, [thumbNails]);

    // Memoize the address string
    const addressString = useMemo(() => (
        `${item.address.toUpperCase()}, ${item.city.toUpperCase()} ${item.state.toUpperCase()}`
    ), [item.address, item.city, item.state]);

    return (
        <div className="col-xl-3 col-lg-4 col-sm-6 col-12" key={item.key} onMouseEnter={onMouseEnter ? onMouseEnter : undefined}>
            <div className="card property border-0 shadow position-relative overflow-hidden rounded-3 h-100">

                <Link to={`/my-property-detail/${item.id}`} className="title fs-5 text-dark fw-medium">
                    <div className="property-image position-relative overflow-hidden shadow">
                        {thumbNails[0]?.thumbnailUrl ? (
                            <img
                                alt={`${item.address}-Unit:${item.unit}`}
                                className="img-fluid w-100"
                                loading="lazy"
                                // width="255"
                                // height="191"
                                src={thumbNails[0].thumbnailUrl}
                                onError={(e) => {
                                    console.error('Image failed to load:', e);
                                    e.target.style.display = 'none';
                                }}
                            />
                        ) : (

                            <img
                                alt={`${item.address}-Unit:${item.unit}`}
                                className="img-fluid w-100"
                                loading="lazy"
                                // width="255"
                                // height="191"
                                src="/ImageNotFound.png"

                                onError={(e) => {
                                    console.error('Image failed to load:', e);
                                    e.target.style.display = 'none';
                                }}
                            />


                        )}
                    </div>
                </Link>
                <div className="card-body content p-0" onClick={() => handlePropertyClicked({ lat: item.lat, lng: item.lng })}>
                    <ul className="list-unstyled mb-0 align-items-start justify-content-start d-flex gap-2 flex-column py-3 px-1 fs-7 min_height_140px">
                        <li className="d-flex align-items-center me-1 ms-2 fw-bold">
                            <p className="p-card letterspacing-1 property_title" style={{ lineHeight: "1rem" }}>{`${item.address.toUpperCase()}, ${item.city.toUpperCase()} ${item.state.toUpperCase()}`}</p>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <p className="p-card" style={{ lineHeight: "1rem" }}>{`UNIT ${item.unit.toUpperCase()}`}
                                <span style={{ fontWeight: "bold" }} className='price_absolute'>
                                    {/* {`$${item.price}/month`} */}
                                    {`${((item.price > 0) && (item?.available) && (item?.availableDt!=="0001-01-01T00:00:00")) ? `$${item.price}/month` : 'Not Available'}`}
                                </span>
                            </p>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <ul className="list-unstyled d-flex align-items-center justify-content-between flex-wrap gap-xxl-2 gap-xl-1 gap-lg-2 gap-sm-1 gap-2">
                                <li className="no-indent ms-0"><p className="p-card property_txt"> <img src={beds} className="property_icon me-1" /> {`Beds: ${item.beds}`}</p></li>
                                <li className="no-indent ms-0"><p className="p-card property_txt"><img src={baths} className="property_icon me-1" /> {`Baths: ${item.baths}`}</p></li>
                                <li className="no-indent ms-0"><p className="p-card property_txt"><img src={sqft} className="property_icon me-1" /> {`Sqft: ${item.sqft}`}</p></li>
                            </ul>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <ul className="list-unstyled d-flex align-items-center justify-content-between">
                                {/* <li className="no-indent"><p className="p-card">{`Available: ${item.available === true ? 'Yes' : 'No'}`}</p>
                                </li>&nbsp;&nbsp; */}
                                {((item.availableDt !== "0001-01-01T00:00:00") && (item?.available) && (item?.price > 0) ) ?
                                    <li className="no-indent ms-0">
                                        <p className="p-card property_txt">
                                            <img src={calendar} className="property_icon me-1" />
                                            {`Availability Date: ${formatDate(item.availableDt)}`}</p>
                                    </li>
                                    : <li className="no-indent ms-0">
                                        <p className="p-card property_txt">
                                            <img src={calendar} className="property_icon me-1" /> {`Availability Date: Not Available`}
                                        </p>
                                    </li>}
                            </ul>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <ul className="list-unstyled d-flex align-items-center">
                                {/* <li className="no-indent"><p className="p-card">{`Available: ${item.available === true ? 'Yes' : 'No'}`}</p>
                                </li>&nbsp;&nbsp; */}
                                {item?.minTermMos ? <li className="no-indent ms-0"><p className="p-card"><img src={term} className="property_icon me-1" /> {`Minimum Term: ${item.minTermMos}`}</p></li> : null}
                            </ul>
                        </li>
                        {item?.amenities && item?.amenities?.length > 0 && (
                            <li className="d-flex  me-1 ms-2 flex-column align-items-start mt-2 mt-sm-0">
                                <p className="p-card fw-bold mb-1 property_txt">Amenities:</p>
                                <ul className="list-unstyled ms-0 mb-2 fs-7 d-flex justify-content-start align-items-start gap-1 flex-wrap property_txt">
                                    {item.amenities.map((amenity, index) => (
                                        <li key={index} style={{ listStyleType: 'disc', marginLeft: '1rem' }} className='marker_color'>
                                            {amenity}
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        )}

                        {/*<li><button onClick={()=> handleApplyNowClicked({id:item.id})}>Inquire</button></li>*/}
                    </ul>
                </div>
            </div>
        </div>
    )
});

export default PropertyCard;